(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('AlarmListController', AlarmListController);

    AlarmListController.$inject = ['$scope', '$rootScope', '$state', '$filter', 'AlarmService', 'Authenticate'];

    function AlarmListController($scope, $rootScope, $state, $filter, AlarmService, Authenticate) {
        var vm = this;

        // Actions
        vm.clearAlarmHistory = clearAlarmHistory;
        vm.currentPage = 1;
        vm.totalCount = 0;
        vm.itemsPerPage = 50; 
        vm.getData = getData;

        if (!Authenticate.hasPermission('alarmList')) {
            return;
        }

        vm.alarmList = {};

        vm.orderBy = function (column) {
            if (vm.order == column) {
                vm.order = '-' + column;
            } else {
                vm.order = column;
            }
        };


        var cancelHistoryListener = $rootScope.$on('filterDataUpdateHistory', successHistoryList);
        $rootScope.$on('$destroy', cancelHistoryListener);

        function successHistoryList(event, data) {
            console.log(data);
            vm.totalCount = data.totalElements;
            vm.alarmList.history = data.content.map(function (item) {
                var date = new Date(item.dateTime);
                item.dateTime = date;
                item.time = $filter('date')(date, 'HH mm');
                item.severity = item.severity.toLowerCase();
                return item;
            });
        } 
           

        var cancelListener = $rootScope.$on('filterDataUpdate', successList);
        $rootScope.$on('$destroy', cancelListener);

        function successList(event, data) {
            for (var type in data) {
                if (type === 'history') {
                    continue;
                }
                vm.alarmList[type] = data[type].map(function (item) {
                    var date = new Date(item.dateTime);
                    item.dateTime = date;
                    item.time = $filter('date')(date, 'HH mm');
                    item.severity = item.severity.toLowerCase();
                    return item;
                });
            }
        }

        function clearAlarmHistory() {
            AlarmService.clearAlarmHistory().then(clearAlarmHistorySuccess).catch(clearAlarmHistoryError);
        }

        function clearAlarmHistorySuccess(response) {
            AlarmService.successModalConstructor('clearAlarmHistory');
            AlarmService.getAlarmList().then(alarmListSuccess).catch(alarmListError);
        }

        function clearAlarmHistoryError(response) {
            AlarmService.errorModalConstructor(response, 'clearAlarmHistory');
        }

        function alarmListSuccess(data) {
            $rootScope.$emit('filterDataUpdate', data);
        }

        function alarmListError(response) {
            AlarmService.errorModalConstructor(response, 'filter');
        }

        function getData(pageNumber) {
            vm.currentPage = pageNumber;   
            var data = {
                currentPage : (pageNumber - 1)
            }
            AlarmService.getAlarmHistoryList(data).then(localList).catch(alarmListError);  
        }

        function localList(data) {
            vm.totalCount = data.totalElements;
            vm.alarmList.history = data.content.map(function (item) {
                var date = new Date(item.dateTime);
                item.dateTime = date;
                item.time = $filter('date')(date, 'HH mm');
                item.severity = item.severity.toLowerCase();
                return item;
            });
        } 

    }
})();